import type { Item } from '../types';
import { formatAgo, useI18n } from '../i18n';

export function ItemList({ items, emptyHint }: { items: Item[]; emptyHint?: string }) {
  const { t } = useI18n();
  if (items.length === 0) {
    return <div className="empty">{emptyHint ?? ''}</div>;
  }
  return (
    <ul className="item-list">
      {items.map((item) => (
        <li key={item.id} className="item">
          <span className="item-kind">{t(`capture.kind.${item.kind}`)}</span>
          <div className="item-body">
            <div className="item-content">{item.content}</div>
            <div className="item-meta">
              <span>{formatAgo(item.createdAt, t)}</span>
              {item.tags.map((tag) => (
                <span key={tag} className="item-tag">
                  #{tag}
                </span>
              ))}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
